import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/downloads";
const FALLBACK_MESSAGE = "Failed to load download items.";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getDownloadItems() {
  return request("/items/");
}
